import {trigger, state, animate, style, transition, query, keyframes, group } from '@angular/animations';
import { HostListener } from '@angular/core';

export function routerAnimation() {
    return routerAnimations();
}

function routerAnimations(){
  return trigger('routerAnimation', [
      transition('* => private', zoomIn()),
      transition('* => public', zoomOut()),
  ])
}

function zoomIn(){
    return [
      group([
        query(':leave', 
          [
            style({ position: 'fixed',top:'0',left:'0',right:'0',bottom:'0',margin:'0 auto', transform: 'scale(1)',opacity: 1 }),
            animate('0.5s ease-in-out', style({ transform: 'scale(5)',opacity:0 }))
          ], 
          { optional: true }
        ),
        query(':enter', 
          [
            style({ position: 'fixed',top:'0',left:'0',right:'0',bottom:'0',margin:'0 auto', transform: 'scale(0)',opacity: 0 }),
            animate('0.5s ease-in-out', style({ transform: 'scale(1)', opacity: 1 }))
          ], 
          { optional: true }
        ),
      ])
    ]
}
  
function zoomOut(){
    return [
      group([
        query(':leave', 
          [
            style({ position: 'fixed',top:'0',left:'0',right:'0',bottom:'0',margin:'0 auto', transform: 'scale(1)',opacity: 1 }),
            animate('0.5s ease-in-out', style({ transform: 'scale(0)',opacity:0 }))
          ], 
          { optional: true }
        ),
        query(':enter', 
          [
            style({ position: 'fixed',top:'0',left:'0',right:'0',bottom:'0',margin:'0 auto', transform: 'scale(5)',opacity: 0 }),
            animate('0.5s ease-in-out', style({ transform: 'scale(1)', opacity: 1 }))
          ], 
          { optional: true }
        ),
      ])
    ]
}


// WEBPACK FOOTER //
// C:/Users/cmcever/Documents/GitHub/ChallengerTurf/EPSePortal/src/app/app.animations.ts